import { parsePhoneNumber } from 'libphonenumber-js'

export const isPhoneNumberValid = (phoneNumber: string): boolean => {
    if (phoneNumber.length > 5) {
        const parsedPhoneNumber = parsePhoneNumber(phoneNumber)
        return parsedPhoneNumber !== undefined && parsedPhoneNumber.isValid()
    }
    return false
}
